import type React from "react"
import { useState } from "react"
import "./tabs.css"

export interface TabItem {
  id: string
  label: string
  content: React.ReactNode,
  onClick?:(value:string)=>void;
}

interface DynamicTabsProps {
  tabs: TabItem[]
  defaultActiveTab?: string
  className?: string
}

const DynamicTabs: React.FC<DynamicTabsProps> = ({ tabs, defaultActiveTab, className = "" }) => {
  
  const [activeTab, setActiveTab] = useState<string>(defaultActiveTab || tabs[0]?.id || "")

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId)
  }

  return (
    <div className={`dynamic-tabs-container ${className}`}>
      {/* Tab Navigation */}
      <ul className="nav nav-tabs custom-nav-tabs" role="tablist">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab.id} role="presentation"  onClick={()=>{tab.onClick(tab.id)}}>
            <button
              className={`nav-link custom-nav-link ${activeTab === tab.id ? "active" : ""}`}
              type="button"
              role="tab"
              aria-controls={`${tab.id}-pane`}
              aria-selected={activeTab === tab.id}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      <div className="tab-content custom-tab-content">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
            id={`${tab.id}-pane`}
            role="tabpanel"
            aria-labelledby={`${tab.id}-tab`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  )
}

export default DynamicTabs
